/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Prompt
 */
export interface Prompt {
    /**
     * 
     * @type {string}
     * @memberof Prompt
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Prompt
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Prompt
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Prompt
     */
    provider?: string;
    /**
     * 
     * @type {string}
     * @memberof Prompt
     */
    model?: string;
    /**
     * 
     * @type {string}
     * @memberof Prompt
     */
    context?: string;
    /**
     * 
     * @type {number}
     * @memberof Prompt
     */
    budget_tokens?: number;
    /**
     * 
     * @type {string}
     * @memberof Prompt
     */
    prompt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Prompt
     */
    include_main_context?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Prompt
     */
    allowed_tools?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Prompt
     */
    requires_patient?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Prompt
     */
    requires_template?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Prompt
     */
    requires_document?: boolean;
}

/**
 * Check if a given object implements the Prompt interface.
 */
export function instanceOfPrompt(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function PromptFromJSON(json: any): Prompt {
    return PromptFromJSONTyped(json, false);
}

export function PromptFromJSONTyped(json: any, ignoreDiscriminator: boolean): Prompt {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'provider': !exists(json, 'provider') ? undefined : json['provider'],
        'model': !exists(json, 'model') ? undefined : json['model'],
        'context': !exists(json, 'context') ? undefined : json['context'],
        'budget_tokens': !exists(json, 'budget_tokens') ? undefined : json['budget_tokens'],
        'prompt': !exists(json, 'prompt') ? undefined : json['prompt'],
        'include_main_context': !exists(json, 'include_main_context') ? undefined : json['include_main_context'],
        'allowed_tools': !exists(json, 'allowed_tools') ? undefined : json['allowed_tools'],
        'requires_patient': !exists(json, 'requires_patient') ? undefined : json['requires_patient'],
        'requires_template': !exists(json, 'requires_template') ? undefined : json['requires_template'],
        'requires_document': !exists(json, 'requires_document') ? undefined : json['requires_document'],
    };
}

export function PromptToJSON(value?: Prompt | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'provider': value.provider,
        'model': value.model,
        'context': value.context,
        'budget_tokens': value.budget_tokens,
        'prompt': value.prompt,
        'include_main_context': value.include_main_context,
        'allowed_tools': value.allowed_tools,
        'requires_patient': value.requires_patient,
        'requires_template': value.requires_template,
        'requires_document': value.requires_document,
    };
}

